module.exports = __webpack_public_path__ + "img/img_12.94fd71ad.jpg";